export const PreviousPageArrow = ({ height }) => {
  return (
    <svg
      fill="#000000"
      height={height}
      viewBox="-9.5 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>left</title>
      <path d="M12.52 22.24c-0.12 0-0.24-0.040-0.36-0.080l-11.68-5.4c-0.28-0.12-0.48-0.44-0.48-0.76s0.2-0.64 0.48-0.76l11.64-5.4c0.24-0.12 0.56-0.12 0.8 0.040s0.4 0.44 0.4 0.72v10.84c0 0.28-0.16 0.56-0.4 0.72-0.12 0.040-0.28 0.080-0.4 0.080zM2.88 16l8.8 4.12v-8.24l-8.8 4.12z"></path>
    </svg>
  );
};

export const NextPageArrow = ({ height }) => {
  return (
    <svg
      fill="#000000"
      height={height}
      viewBox="-9.5 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.84 22.243c-0.16 0-0.32-0.040-0.44-0.12-0.24-0.16-0.4-0.44-0.4-0.72v-10.8c0-0.28 0.16-0.56 0.4-0.72s0.56-0.16 0.8-0.040l11.64 5.4c0.28 0.12 0.48 0.44 0.48 0.76s-0.2 0.64-0.48 0.76l-11.68 5.4c-0.12 0.080-0.2 0.080-0.32 0.080zM1.64 11.883v8.2l8.8-4.12-8.8-4.080z"></path>
    </svg>
  );
};

export const FirstPageArrow = ({ height }) => {
  return (
    <svg height={height} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(10,-5) scale(1.8)">
        <path d="M12.52 22.24c-0.12 0-0.24-0.040-0.36-0.080l-11.68-5.4c-0.28-0.12-0.48-0.44-0.48-0.76s0.2-0.64 0.48-0.76l11.64-5.4c0.24-0.12 0.56-0.12 0.8 0.040s0.4 0.44 0.4 0.72v10.84c0 0.28-0.16 0.56-0.4 0.72-0.12 0.040-0.28 0.080-0.4 0.080zM2.88 16l8.8 4.12v-8.24l-8.8 4.12z"></path>
      </g>
      <g transform="translate(0, 5) scale(0.8)">
        <path d="M9,44a2,2,0,0,0,2-2V6A2,2,0,0,0,7,6V42A2,2,0,0,0,9,44Z" />
      </g>
    </svg>
  );
};

export const LastPageArrow = ({ height }) => {
  return (
    <svg height={height} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(20, 5) scale(0.8)">
        <path d="M9,44a2,2,0,0,0,2-2V6A2,2,0,0,0,7,6V42A2,2,0,0,0,9,44Z" />
      </g>
      <g transform="translate(0,-5) scale(1.8)">
        <path d="M0.84 22.243c-0.16 0-0.32-0.040-0.44-0.12-0.24-0.16-0.4-0.44-0.4-0.72v-10.8c0-0.28 0.16-0.56 0.4-0.72s0.56-0.16 0.8-0.040l11.64 5.4c0.28 0.12 0.48 0.44 0.48 0.76s-0.2 0.64-0.48 0.76l-11.68 5.4c-0.12 0.080-0.2 0.080-0.32 0.080zM1.64 11.883v8.2l8.8-4.12-8.8-4.080z" />
      </g>
    </svg>
  );
};
